import type { IImage } from 'old-store/types/gallery';

export const isDisplayableImage = (img: IImage): boolean => {
  const isGif = img.extension.toLowerCase() === 'gif';

  return (isGif || img.compressionStatus === 'done') && Boolean(img?.width) && Boolean(img?.height);
};

export const createSelectableImageFilter =
  ({ endCustomerId, visibleIds }: { endCustomerId: string; visibleIds?: Set<string> | null }) =>
  (img: IImage): boolean =>
    Boolean(img.gallery_id) &&
    (!visibleIds || visibleIds.has(img._id)) &&
    !img.hiddenBy?.includes(endCustomerId);
